// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mR4M","title":"styles_title__24fgd"};